import Vue from 'vue'

export default async (id) => {
  const res = await Vue.axios.get(`/billing/package/${id}`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/fetch-package.js